/**
 * Dutch-aware title case voor namen.
 *
 *   "jan de vries"     → "Jan de Vries"
 *   "AHMED EL AMRANI"  → "Ahmed el Amrani"
 *   "mcdonald"         → "McDonald"
 *   "o'brien"          → "O'Brien"
 *   "mary-jane van der berg" → "Mary-Jane van der Berg"
 *
 * Tussenvoegsels (de, van, der, etc.) blijven kleine letter behalve aan het begin.
 */

const TUSSEN = new Set([
  'de', 'der', 'den', 'des', 'het', "'t",
  'van', 'ten', 'ter',
  'op', 'in', 'aan', 'bij', 'tot', 'uit', 'onder', 'boven',
  'le', 'la', 'el', 'al',
  'di', 'da', 'do', 'del', 'della', 'di',
  'of', 'and', 'y'
]);

// Schotse / Ierse prefixen die hoofdletter behouden ná de prefix.
const PREFIX_CAP_AFTER = ['mc', 'mac', 'o\''];

function capWord(w) {
  if (!w) return w;
  const lower = w.toLowerCase();

  // Mc / Mac / O' prefix → "McDonald", "MacKay", "O'Brien"
  for (const p of PREFIX_CAP_AFTER) {
    if (lower.startsWith(p) && lower.length > p.length) {
      return p.charAt(0).toUpperCase() + p.slice(1) + lower.charAt(p.length).toUpperCase() + lower.slice(p.length + 1);
    }
  }

  // Hyphenated: "mary-jane" → "Mary-Jane"
  if (lower.includes('-')) {
    return lower.split('-').map(capWord).join('-');
  }
  // Apostrof binnen woord: "d'arc" → "D'Arc"
  if (lower.includes("'") && !lower.startsWith("'")) {
    return lower.split("'").map((p, i) => i === 0 ? capWord(p) : capWord(p)).join("'");
  }

  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export function titleCaseName(input) {
  if (!input) return '';
  const s = String(input).trim().replace(/\s+/g, ' ');
  if (!s) return '';
  return s.split(' ').map((w, i) => {
    const lower = w.toLowerCase();
    // Tussenvoegsel? Nooit als eerste woord lowercase laten.
    if (i > 0 && TUSSEN.has(lower)) return lower;
    return capWord(w);
  }).join(' ');
}

// Zelfde voor plaatsnamen (zonder tussenvoegsel-uitzondering — die zijn al netjes vanuit PDOK).
export function titleCasePlace(input) {
  if (!input) return '';
  return String(input).trim().replace(/\s+/g, ' ').split(' ').map(capWord).join(' ');
}

// Alleen eerste letter hoofdletter, rest blijft (bv. voor product-omschrijvingen, notities).
export function sentenceCase(input) {
  if (!input) return '';
  const s = String(input).trim().replace(/\s+/g, ' ');
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}
